import { Button, Col, Drawer, Form, Input, InputNumber, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useState } from 'react';
import {
  createResourceGroup,
  updateResourceGroup,
} from '../../../../api/admin/permission';
import { messageError, messageSuccess } from '../../../../components/message';
import getFormatMessage from '../../../../locales/get-format-message';
import { IServicePermissionsGroupItem } from '../../../../model';
import { IPermissionResourceType } from '../../../../model/api-modules';

interface IProps {
  readonly onClose: (status?: boolean) => void;
  readonly row: IServicePermissionsGroupItem | null;
  readonly type: IPermissionResourceType;
}

export const GroupDrawer = (props: IProps) => {
  const [form] = useForm<any>();
  // const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  const getModalTitle = () => {
    if (props.type === IPermissionResourceType.Create) {
      return getFormatMessage('create_group');
    }
    return getFormatMessage('edit_group');
  };
  const showSuccessMessage = () => {
    messageSuccess(
      props.type === IPermissionResourceType.Create
        ? getFormatMessage('create_success')
        : getFormatMessage('edit_success')
    );
  };
  const handleOpenCancel = () => {
    form.resetFields();
    props.onClose();
  };
  const handleOpenSubmit = async () => {
    const values = await form.validateFields();
    setLoading(true);
    if (!values) {
      return;
    }
    try {
      const trimmedName = values.objectGroupName.trim();
      const valuesForm = {
        ...values,
        objectGroupName: trimmedName,
      };
      let res;
      // const res={data:[],code:0};
      if (props.type === IPermissionResourceType.Edit && props.row) {
        res = await updateResourceGroup({
          objectGroupId: props.row?.objectGroupId,
          ...valuesForm,
        });
      } else if (props.type === IPermissionResourceType.Create) {
        res = await createResourceGroup({
          ...valuesForm,
        });
      }
      if (res) {
        showSuccessMessage();
        form.resetFields();
        props.onClose(true);
      } else {
        messageError(getFormatMessage('failed_submit'));
      }
    } catch (error: any) {
      messageError(
        error?.apiError?.message || getFormatMessage('failed_submit')
      );
      return false;
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (props.type === IPermissionResourceType.Edit) {
      form.setFieldsValue({
        ...props.row,
        sort: props.row?.sort || 0,
      });
    }
    setInit(true);
  }, [props.type]);
  const renderFormItems = () => {
    // const disabled = props.type === IPermissionResourceType.Edit;
    return (
      <>
        <div className="drawer-download-text">
          {props.row?.objectGroupId ? (
            <div className="drawer-download-h" style={{ margin: 10 }}>
              {getFormatMessage('objectGroupId')}:{props.row?.objectGroupId}
            </div>
          ) : null}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="parentId"
                label={getFormatMessage('parentId')}
                rules={[{ required: true }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <InputNumber></InputNumber>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="objectGroupName"
                label={getFormatMessage('name_uppercase')}
                rules={[{ required: true }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input
                  placeholder={getFormatMessage('please_enter_group_name')}
                />
              </Form.Item>
            </Col>
          </Row>
          {props.row &&
            (!props.row?.children || props.row?.children?.length === 0) &&
            props.row?.parentId !== 0 && (
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name="sort"
                    label="排序值（从大到小排序，默认值0，最大1000）"
                    rules={[{ required: true }]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <InputNumber min={0} max={1000} />
                  </Form.Item>
                </Col>
              </Row>
            )}
        </div>
      </>
    );
  };

  if (!init) return null;
  return (
    <Drawer
      onClose={() => props.onClose()}
      title={<p className="fail-title">{getModalTitle()}</p>}
      placement="right"
      width={520}
      closable={false}
      visible={true}
      headerStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        marginLeft: '3px',
      }}
      footer={
        <div
          style={{
            textAlign: 'left',
          }}
        >
          <Button
            className="sub-button"
            onClick={handleOpenCancel}
            disabled={loading}
          >
            {getFormatMessage('cancel')}
          </Button>
          <Button
            className="gc-btn gc-btn-primary gc-btn-download"
            loading={loading}
            onClick={handleOpenSubmit}
          >
            {getFormatMessage('submit')}
          </Button>
        </div>
      }
    >
      <Form form={form}>{renderFormItems()}</Form>
    </Drawer>
  );
};
